export interface AuthUser {
  displayName: string;
  email: string;
  id: string;
  phoneNumber: string;
}

export interface AuthActor {
  activeOrganizationId: string;
  organizationType: "agency" | "customer" | "system";
  userId: string;
}

export type OnboardingServerStatus = "completed" | "draft" | "missing";

export interface AuthSessionState {
  actor: AuthActor | null;
  onboardingRevision: number;
  onboardingStatus: OnboardingServerStatus;
  status: "authenticated" | "booting" | "guest";
  user: AuthUser | null;
  welcomeMotionSeen: boolean;
}

export function createBootingAuthSession(): AuthSessionState {
  return {
    actor: null,
    onboardingRevision: 0,
    onboardingStatus: "missing",
    status: "booting",
    user: null,
    welcomeMotionSeen: false,
  };
}

export function createGuestAuthSession(): AuthSessionState {
  return {
    ...createBootingAuthSession(),
    status: "guest",
  };
}
